	//Calculates the total amount necessary to be eligible for free shipping 
//and displays it in the ajax cart


console.log("free-shipping.js init");	

function displayFreeShippingThreshold() {
	Knocking.loadCart(callback_get_total_Price);
};

function callback_get_total_Price(response) {
	let resPrice = response.original_total_price;
	let total_price = resPrice / 100;
	print_to_Cart(total_price, freeShippingThresholdEnable);
};

function print_to_Cart(total_price, freeShippingThresholdEnable) {
	var diffFreeShipping = 0;
 	diffFreeShipping = freeShippingThreshold - total_price;
 	diffConverted = new Intl.NumberFormat('en-IN', { style: 'decimal', minimumFractionDigits: 2 } ).format((freeShippingThreshold - total_price));
	
	if (freeShippingThresholdEnable == "true") {
		if( total_price < freeShippingThreshold ) {
			let notEligibleOutput = freeShippingNotEligible.replace("[diffConverted]", diffConverted);	
			$('#displayFreeShippingThreshold').html("<img class='shipping__icon' src='https://cdn.shopify.com/s/files/1/0175/6266/5060/files/ajax_cart-shipping__icon_1bbaed2a-686f-4c00-9af0-920e5a65fc95.png'><div class='shipping__text'><span>" + notEligibleOutput + "</span></div>")
			$('#displayFreeShippingThreshold').removeClass('freeShippingGreenLight').addClass('freeShippingRedLight')
		} else {
			let EligibleOutput = freeShippingEligible.replace("[diffConverted]", diffConverted);
			$('#displayFreeShippingThreshold').html("<img class='shipping__icon' src='https://cdn.shopify.com/s/files/1/0175/6266/5060/files/ajax_cart-shipping__icon_1bbaed2a-686f-4c00-9af0-920e5a65fc95.png'><div class='shipping__text'><span>" + EligibleOutput + "</span></div>")
			$('#displayFreeShippingThreshold').removeClass('freeShippingRedLight').addClass('freeShippingGreenLight')
		}
	} else {
		$('#displayFreeShippingThreshold').html("<span></span>")
	}
}
